import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ArrowCircleBrokenRightIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8958 8.90027C12.1882 8.60687 12.663 8.60605 12.9564 8.89844L15.9874 11.919C16.1287 12.0598 16.2081 12.251 16.208 12.4504C16.208 12.6499 16.1285 12.8411 15.9872 12.9818L12.9562 15.9995C12.6627 16.2917 12.1878 16.2907 11.8955 15.9972C11.6033 15.7036 11.6043 15.2288 11.8979 14.9365L13.6417 13.2003H3.03418C2.61997 13.2003 2.28418 12.8645 2.28418 12.4503C2.28418 12.0361 2.61997 11.7003 3.03418 11.7003H13.6429L11.8976 9.96094C11.6042 9.66855 11.6034 9.19367 11.8958 8.90027Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.76413 7.17313C5.49792 4.48189 8.52317 2.69727 11.966 2.69727C17.3501 2.69727 21.716 7.06209 21.716 12.4472C21.716 17.8324 17.3501 22.1972 11.966 22.1972C8.52317 22.1972 5.49792 20.4126 3.76413 17.7214C3.5398 17.3731 3.64023 16.909 3.98844 16.6847C4.33665 16.4604 4.80078 16.5608 5.02511 16.909C6.49441 19.1897 9.05419 20.6972 11.966 20.6972C16.5218 20.6972 20.216 17.0039 20.216 12.4472C20.216 7.89062 16.5218 4.19727 11.966 4.19727C9.05419 4.19727 6.49441 5.70481 5.02511 7.9855C4.80078 8.33371 4.33665 8.43413 3.98844 8.2098C3.64023 7.98548 3.53981 7.52134 3.76413 7.17313Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default ArrowCircleBrokenRightIcon;
